import { render, staticRenderFns } from "./ProfileBreadCrumbs.vue?vue&type=template&id=3fcd7913&scoped=true"
import script from "./ProfileBreadCrumbs.vue?vue&type=script&lang=js"
export * from "./ProfileBreadCrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcd7913",
  null
  
)

export default component.exports